import React from 'react';
import { twMerge } from 'tailwind-merge';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'glass' | 'orange' | 'dark';
  pulse?: boolean;
  className?: string;
}

const variants = {
  glass: 'glass text-white/90',
  orange: 'bg-primary/10 text-primary border border-primary/20',
  dark: 'bg-dark-card text-white/80 border border-white/10',
};

export default function Badge({
  children,
  variant = 'glass',
  pulse = false,
  className,
}: BadgeProps) {
  return (
    <span
      className={twMerge(
        'inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium',
        variants[variant],
        pulse && 'animate-pulse',
        className
      )}
    >
      {children}
    </span>
  );
}
